import {
  Chip,
  Card,
  CardBody,
  CardHeader,
  Typography,
} from "@material-tailwind/react";
import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useSelector } from "react-redux";
import Notes from "./Notes";
import { httpMushPro } from "../../../services/http-common";
import { toast } from "react-toastify";
import {
  appointmentStatus,
  formatFullTime,
  timeAgo,
} from "../../../utils/dateFormat";

const Overview = () => {
  const { selectedSeekerDetails } = useSelector((state) => state.dataFlow);
  const [allNotifications, setAllNotifications] = useState(null);

  const getSeekersList = useMutation(
    () => {
      return httpMushPro.post("user/notifications/fetch-by-seeker", {
        seekerId: selectedSeekerDetails?.attendees?.seekerId,
      });
    },
    {
      onSuccess: ({ data }) => {
        setAllNotifications(data.notifications);
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
    }
  );

  useEffect(() => {
    getSeekersList.mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div >
       <Card variant="gradient" className="w-full p-8">
      <CardHeader
        floated={false}
        shadow={false}
        color="transparent"
        className="m-0 rounded-none border-b border-white/10 pb-8 text-center"
      >
        <Typography
          variant="small"
          className="font-normal normal-case text-[#000080]"
        >
          EntheoID
        </Typography>
        <Typography
          variant="h1"
          className="mt-1 flex justify-center gap-1 text-2xl font-normal"
        >
{selectedSeekerDetails?.attendees?.user?.firstName}        </Typography>
      </CardHeader>
      <CardBody className="p-0">
        <ul className="flex flex-col gap-1">
          <li className="flex items-center gap-4">
            
            <Typography className="font-normal">
            <p>
              <span className="font-bold mr-1">Last Interaction: </span>
              {timeAgo(selectedSeekerDetails?.lastInteraction)}
            </p>
            </Typography>
          </li>
          <li className="flex items-center gap-4">
            
            <Typography className="font-normal"><p>
              <span className="font-bold mr-1">Priority Status: </span>
              {selectedSeekerDetails?.attendees?.pinned ? "High" : "Low"}
            </p></Typography>
          </li>
          <li className="flex items-center gap-4">
            
            <Typography className="font-normal"><p>
              <span className="font-bold mr-1">Appointment Status: </span>
              Scheduled for {formatFullTime(selectedSeekerDetails?.startDate)}
            </p></Typography>
          </li>
        
        </ul>
      </CardBody>
    </Card>
      <Card className="my-5">
      <CardBody>
        <div className="mb-4 flex items-center justify-between">
          <Typography variant="h5" color="blue-gray" >
          Reminders & Recent Activities
          </Typography>
          
        </div>
        <div className="divide-y divide-gray-200">
          {allNotifications &&
            allNotifications.map((notification , index) => (
            <div
              key={index}
              className="flex items-center justify-between pb-3 pt-3 last:pb-0"
            >
              <div className="flex items-center gap-x-3">
                <div>
                  <Typography color="blue-gray" variant="h6">
                  Title: {notification.title}
                  </Typography>
                  <Typography variant="small" color="gray">
                    {notification.description}
                  </Typography>
                </div>
              </div>
              <Typography color="blue-gray" variant="h6">
                {formatFullTime(notification.updated_at)}
              </Typography>
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
      <Notes />
    </div>
  );
};

export default Overview;
